import React, { useState } from 'react';
import BodyContainer from '../ui/BodyContainer';
import CustomButton from '../ui/viewEventUi/CustomButton';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { useHistory, useLocation } from 'react-router-dom';
import Services from '../services/services';
import Loader from '../ui/Loader';
import ChangePassSkeleton from '../ui/changePassSkeleton';
import changePassStyles from '../styles/changePasswStyles';
import toast, { Toaster } from 'react-hot-toast';
import {
  getUserBrowserStorage,
  checkPassword,
  passwordHelper,
} from '../constants';
import { backArrow } from '../ui/icons';

const useStyles = makeStyles((theme) => changePassStyles(theme));

function Payment() {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();

  const pathCustom = location.state?.pathCustom;
  const userDetails = JSON.parse(getUserBrowserStorage('userDetails'));
  const [loader, setLoader] = React.useState(false);
  const [oldPass, setOldPass] = useState({
    error: false,
    helpertext: ' ',
    value: '',
  });
  const [newPass, setNewPass] = useState({
    error: false,
    helpertext: ' ',
    value: '',
  });
  const [confPass, setConfPass] = useState({
    error: false,
    helpertext: ' ',
    value: '',
  });

  // const checkPassword = (str) => {
  //   const remSpace = str.trim();
  //   var re = /.{9,}/;
  //   return re.test(remSpace);
  // };

  const onChangeOldPass = (e) => {
    const value = e.target.value;
    setOldPass({
      error: false,
      helpertext: ' ',
      value: value,
    });
  };

  const handleEnter = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault();
      changePassFun();
    }
  };

  const updateNewPass = (newErr, newHelp = ' ', newVal) => {
    setNewPass({
      error: newErr,
      helpertext: newHelp,
      value: newVal,
    });
    setConfPass((prevState) => {
      return {
        ...prevState,
        error: false,
        helpertext: ' ',
      };
    });
  };

  const onChangeNewPass = (e) => {
    const value = e.target.value.trim();
    if (value === '' || !checkPassword(value)) {
      updateNewPass(false, passwordHelper, value);
    } else {
      updateNewPass(false, ' ', value);
    }
  };

  const onChangeConfPass = (e) => {
    const value = e.target.value;
    setConfPass({
      error: false,
      helpertext: ' ',
      value: value,
    });
  };
  const Validation_fun = () => {
    if (oldPass.value === '') {
      setOldPass((prevState) => {
        return {
          ...prevState,
          error: true,
          helpertext: 'Old password is required',
        };
      });
    }
    if (newPass.value === '') {
      setNewPass((prevState) => {
        return {
          ...prevState,
          error: true,
          helpertext: 'New password is required',
        };
      });
    } else if (!checkPassword(newPass.value)) {
      setNewPass((prevState) => {
        return {
          ...prevState,
          error: true,
          helpertext: passwordHelper,
        };
      });
    }
    if (confPass.value === '') {
      // setConfPass((prevState) => {
      // return {
      // ...prevState,
      // error: true,
      // helpertext: 'Confirm your password',
      // };
      // });
    } else if (newPass.value !== confPass.value) {
      setConfPass((prevState) => {
        return {
          ...prevState,
          error: true,
          helpertext: 'Passwords are not matching',
        };
      });
    }

    if (
      oldPass.value === '' ||
      oldPass.value === undefined ||
      oldPass.value === null ||
      newPass.value === '' ||
      newPass.value === undefined ||
      newPass.value === null ||
      !checkPassword(newPass.value) ||
      confPass.value === '' ||
      confPass.value === undefined ||
      confPass.value === null ||
      newPass.value !== confPass.value
    ) {
      return false;
    } else {
      return true;
    }
  };
  const changePassFun = () => {
    if (Validation_fun()) {
      let email = userDetails.email;
      setLoader(!loader);
      Services.change_password(email, oldPass.value, confPass.value)
        .then((responce) => {
          if (responce.data.responseCode === 200) {
            setLoader(false);
            toast.success(responce.data.details, { duration: 4000 });
            if (pathCustom) {
              history.push(pathCustom);
            } else if (!userDetails.lastName) {
              history.push('/myprofile');
              return;
            }
            history.push('/');
          } else if (responce.data.responseCode === 401) {
            setLoader(false);
            toast.error(responce.data.details, { duration: 4000 });
          } else {
            setLoader(false);
            toast.error(responce.data.details, { duration: 4000 });
          }
        })
        .catch((error) => {
          setLoader(false);
          toast.error(error, { duration: 4000 });
        });
    }
  };

  const handleBackButton = () => {
    history.goBack();
  };

  return (
    <BodyContainer title='Change Password' icon={backArrow(handleBackButton)}>
      <Grid className={classes.gridOccupy}>
        <Paper elevation={0} className={classes.root}>
          <form className={classes.root}>
            <Grid container>
              <ChangePassSkeleton
                OError={oldPass.error}
                OHelp={oldPass.helpertext}
                OValue={oldPass.value}
                changeOPass={onChangeOldPass}
                handleEnter={handleEnter}
                inputStyles={classes.inputStyles}
                NError={newPass.error}
                NHelp={newPass.helpertext}
                NValue={newPass.value}
                changeNPass={onChangeNewPass}
                CError={confPass.error}
                CHelp={confPass.helpertext}
                CValue={confPass.value}
                changeConfPass={onChangeConfPass}
              />
            </Grid>
            <div className={classes.btnContainer}>
              <CustomButton
                btnStyle={classes.button}
                clickHandle={changePassFun}
                btnText={'Change Password'}
              />
            </div>
          </form>
          {/* <a href="whatsapp://send?text=Hello%20World!">Hello, world!</a> */}
        </Paper>
        <Toaster position='top-center'></Toaster>
        <Loader open={loader} />
      </Grid>
    </BodyContainer>
  );
}

export default Payment;
